import React from 'react';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import useDividerAction from './useDividerAction';
import useInsertMenuNodes from './useInsertMenuNodes';
import MobileRomaMenu from '../../../../../contextMenu/MobileRomaMenu';

type MobileInsertMenuContentPopupProps = {
    closeSheet: () => void;
    onLinkBoard: () => void;
    element?: ImMNElement;
};

const MobileInsertMenuContent: React.FC<MobileInsertMenuContentPopupProps> = ({ closeSheet, onLinkBoard, element }) => {
    const insertDividerLine = useDividerAction();

    const initialNodes = useInsertMenuNodes({
        element,
        actions: {
            // TODO: Proper actions to be added in separate tickets
            insertEmoji: closeSheet,
            insertBoardLink: onLinkBoard,
            insertDividerLine: insertDividerLine,
            insertMention: closeSheet,
        },
    });

    const nodes = initialNodes.map((node) => {
        if (node.id !== 'linkBoard') return node;

        return {
            ...node,
            keepOpenOnSelect: true,
        };
    });

    return <MobileRomaMenu ariaLabel="Insert menu actions" nodes={nodes} showIcons />;
};

export default MobileInsertMenuContent;
